import React, { Component } from "react";
import { connect } from "react-redux";
import { getSelectedWebsiteDomain, getSelectedWebsiteRegionalDatabase } from "../../store/tracked_websites/selectors";
import { TopKeywordsLayout } from "../../components/TopKeywords";
import { getOverview, isFetchingOverview } from "../../store/top_keywords/selectors";
import { fetchTopKeywordsOverview } from "../../store/top_keywords/operations";

class TopKeywords extends Component {
  componentDidMount = _ => {
    this.props.fetchTopKeywordsOverview(this.props.domain, this.props.seoDb);
  };
  render() {
    return (
      <TopKeywordsLayout
        domain={this.props.domain}
        seoDb={this.props.seoDb}
        isLoading={this.props.isLoading}
        overview={this.props.overview}
      />
    );
  }
}

const mapStateToProps = state => ({
  domain: getSelectedWebsiteDomain(state),
  seoDb: getSelectedWebsiteRegionalDatabase(state),
  overview: getOverview(state),
  isLoading: isFetchingOverview(state)
});

export default connect(
  mapStateToProps,
  { fetchTopKeywordsOverview }
)(TopKeywords);
